import { PrimaryGeneratedColumn, Column, OneToMany, Entity, ManyToOne, UpdateDateColumn, CreateDateColumn } from 'typeorm';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol, Iterator */


function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

let BasicItem = class BasicItem {
    id;
    customId;
    name;
    description;
    owner;
    startDate;
    endDate;
    dropdownFieldOne;
    maturity;
    dimension;
    budget;
    projectSpecificItem;
    itemAssignedToAllProjects;
    reportingItems;
    projectIds;
    flag;
};
__decorate([
    PrimaryGeneratedColumn(),
    __metadata("design:type", String)
], BasicItem.prototype, "id", void 0);
__decorate([
    Column({ nullable: true }),
    __metadata("design:type", String)
], BasicItem.prototype, "customId", void 0);
__decorate([
    Column({ nullable: true }),
    __metadata("design:type", String)
], BasicItem.prototype, "name", void 0);
__decorate([
    Column({ type: "text", nullable: true }),
    __metadata("design:type", String)
], BasicItem.prototype, "description", void 0);
__decorate([
    Column({ nullable: true }),
    __metadata("design:type", String)
], BasicItem.prototype, "owner", void 0);
__decorate([
    Column({ type: "date", nullable: true }),
    __metadata("design:type", String)
], BasicItem.prototype, "startDate", void 0);
__decorate([
    Column({ type: "date", nullable: true }),
    __metadata("design:type", String)
], BasicItem.prototype, "endDate", void 0);
__decorate([
    Column({ type: "text", nullable: true }),
    __metadata("design:type", String)
], BasicItem.prototype, "dropdownFieldOne", void 0);
__decorate([
    Column({ type: "text", nullable: true }),
    __metadata("design:type", String)
], BasicItem.prototype, "maturity", void 0);
__decorate([
    Column({ type: "text", nullable: true }),
    __metadata("design:type", String)
], BasicItem.prototype, "dimension", void 0);
__decorate([
    Column({ type: "decimal", precision: 17, scale: 2, nullable: true }),
    __metadata("design:type", Number)
], BasicItem.prototype, "budget", void 0);
__decorate([
    Column({ type: "boolean", nullable: true }),
    __metadata("design:type", Boolean)
], BasicItem.prototype, "projectSpecificItem", void 0);
__decorate([
    Column({ type: "boolean", nullable: true }),
    __metadata("design:type", Boolean)
], BasicItem.prototype, "itemAssignedToAllProjects", void 0);
__decorate([
    OneToMany(() => ReportingItem, (reportingItem) => reportingItem.basicItem, {
        eager: true,
        cascade: true,
        orphanedRowAction: "delete",
    }),
    __metadata("design:type", Array)
], BasicItem.prototype, "reportingItems", void 0);
BasicItem = __decorate([
    Entity()
], BasicItem);

const CONFIGURATION_DROPDOWN_DEFINITION_KEYS = [
    "categoryDefinition",
    "secondCategoryDefinition",
    "dropdownFieldOneDefinition",
    "statusDefinition",
    "degreeOfCompletionDefinition",
    "answerDefinition",
];
let DropdownOption = class DropdownOption {
    id;
    definitionKey;
    name;
    label;
    placeholder;
    color;
    order;
    configuration;
    customFieldDefinition;
};
__decorate([
    PrimaryGeneratedColumn("uuid"),
    __metadata("design:type", String)
], DropdownOption.prototype, "id", void 0);
__decorate([
    Column({
        type: "enum",
        enum: CONFIGURATION_DROPDOWN_DEFINITION_KEYS,
        nullable: true,
    }),
    __metadata("design:type", String)
], DropdownOption.prototype, "definitionKey", void 0);
__decorate([
    Column({ nullable: true }),
    __metadata("design:type", String)
], DropdownOption.prototype, "name", void 0);
__decorate([
    Column({ nullable: true }),
    __metadata("design:type", String)
], DropdownOption.prototype, "label", void 0);
__decorate([
    Column({ nullable: true }),
    __metadata("design:type", String)
], DropdownOption.prototype, "placeholder", void 0);
__decorate([
    Column({ nullable: true }),
    __metadata("design:type", String)
], DropdownOption.prototype, "color", void 0);
__decorate([
    Column({ nullable: true }),
    __metadata("design:type", Number)
], DropdownOption.prototype, "order", void 0);
__decorate([
    ManyToOne(() => Configuration, (configuration) => configuration.dropdownOptions, {
        onDelete: "CASCADE",
        nullable: true,
    }),
    __metadata("design:type", Object)
], DropdownOption.prototype, "configuration", void 0);
__decorate([
    ManyToOne(() => CustomFieldDefinition, (customFieldDefinition) => customFieldDefinition.options, {
        onDelete: "CASCADE",
        nullable: true,
    }),
    __metadata("design:type", Object)
], DropdownOption.prototype, "customFieldDefinition", void 0);
DropdownOption = __decorate([
    Entity()
], DropdownOption);

const PROJECT_NAMES = [
    {
        single: "Project",
        plural: "Projects",
    },
    {
        single: "Measure",
        plural: "Measures",
    },
    {
        single: "Finding",
        plural: "Findings",
    },
    {
        single: "Company",
        plural: "Companies",
    },
    {
        single: "Subsidiary",
        plural: "Subsidiaries",
    },
    {
        single: "Department",
        plural: "Departments",
    },
    {
        single: "OE",
        plural: "OEs",
    },
];
const ITEM_NAMES = [
    { single: "Tracking Item", plural: "Tracking Items" },
    {
        single: "Deliverable",
        plural: "Deliverables",
    },
    {
        single: "Task",
        plural: "Tasks",
    },
    {
        single: "Activity",
        plural: "Activities",
    },
    {
        single: "Milestone",
        plural: "Milestones",
    },
    {
        single: "Measure",
        plural: "Measures",
    },
    {
        single: "Finding",
        plural: "Findings",
    },
    {
        single: "Initiative",
        plural: "Initiatives",
    },
    { single: "Question", plural: "Questions" },
];

let Configuration = class Configuration {
    id;
    isPublished;
    programName;
    programOwner;
    logo;
    programDescription;
    projectName;
    itemName;
    completedConfigurationSteps;
    useCase;
    /**
     * UI language selected when the app was created (from the Home Portal
     * create-app flow). Used to seed localized sample data. Missing values
     * (legacy configurations created before this field existed) must be
     * treated as "en" by all readers.
     */
    defaultLanguage;
    type;
    canProgramTeamCreateProjects;
    canProgramTeamCreateItems;
    canReportingTeamCreateItems;
    trackingItemsApplyToAllProjects;
    categoryLabel;
    fieldsDefinition;
    statusDefinition;
    statusReportingLevel;
    degreeOfCompletionDefinition;
    categoryDefinition;
    maturityDefinition;
    dimensionDefinition;
    secondCategoryDefinition;
    dropdownFieldOneDefinition;
    maturityConfiguration;
    answerDefinition;
    semaphoreStatusDefinition;
    reportingCycle;
    updatedAt;
    publishedAt;
    isReportingEnabled;
    homePortalAppId;
    dropdownOptions;
    customFields;
    client;
    tool;
};
__decorate([
    PrimaryGeneratedColumn(),
    __metadata("design:type", String)
], Configuration.prototype, "id", void 0);
__decorate([
    Column({ nullable: true }),
    __metadata("design:type", Boolean)
], Configuration.prototype, "isPublished", void 0);
__decorate([
    Column({ nullable: true }),
    __metadata("design:type", String)
], Configuration.prototype, "programName", void 0);
__decorate([
    Column({ nullable: true }),
    __metadata("design:type", String)
], Configuration.prototype, "programOwner", void 0);
__decorate([
    Column({ nullable: true }),
    __metadata("design:type", String)
], Configuration.prototype, "logo", void 0);
__decorate([
    Column({ type: "text", nullable: true }),
    __metadata("design:type", String)
], Configuration.prototype, "programDescription", void 0);
__decorate([
    Column("enum", {
        enum: PROJECT_NAMES.map((n) => n.single),
        nullable: true,
    }),
    __metadata("design:type", String)
], Configuration.prototype, "projectName", void 0);
__decorate([
    Column("enum", {
        enum: ITEM_NAMES.map((n) => n.single),
        nullable: true,
    }),
    __metadata("design:type", String)
], Configuration.prototype, "itemName", void 0);
__decorate([
    Column({ nullable: true }),
    __metadata("design:type", String)
], Configuration.prototype, "completedConfigurationSteps", void 0);
__decorate([
    Column("enum", {
        enum: ["pmo", "rollout", "audit", "assessment", "maturity"],
        nullable: true,
    }),
    __metadata("design:type", String)
], Configuration.prototype, "useCase", void 0);
__decorate([
    Column("enum", {
        enum: ["en", "de"],
        nullable: true,
    }),
    __metadata("design:type", String)
], Configuration.prototype, "defaultLanguage", void 0);
__decorate([
    Column("enum", {
        enum: ["project", "item", "reporting", "general"],
        nullable: true,
    }),
    __metadata("design:type", String)
], Configuration.prototype, "type", void 0);
__decorate([
    Column({ nullable: true }),
    __metadata("design:type", Boolean)
], Configuration.prototype, "canProgramTeamCreateProjects", void 0);
__decorate([
    Column({ nullable: true }),
    __metadata("design:type", Boolean)
], Configuration.prototype, "canProgramTeamCreateItems", void 0);
__decorate([
    Column({ nullable: true }),
    __metadata("design:type", Boolean)
], Configuration.prototype, "canReportingTeamCreateItems", void 0);
__decorate([
    Column({ nullable: true }),
    __metadata("design:type", Boolean)
], Configuration.prototype, "trackingItemsApplyToAllProjects", void 0);
__decorate([
    Column({ nullable: true }),
    __metadata("design:type", String)
], Configuration.prototype, "categoryLabel", void 0);
__decorate([
    Column({ type: "jsonb", nullable: true }),
    __metadata("design:type", Array)
], Configuration.prototype, "fieldsDefinition", void 0);
__decorate([
    Column({ type: "jsonb", nullable: true }),
    __metadata("design:type", Array)
], Configuration.prototype, "statusDefinition", void 0);
__decorate([
    Column("enum", {
        enum: ["overall", "category"],
        nullable: true,
    }),
    __metadata("design:type", String)
], Configuration.prototype, "statusReportingLevel", void 0);
__decorate([
    Column({ type: "jsonb", nullable: true }),
    __metadata("design:type", Array)
], Configuration.prototype, "degreeOfCompletionDefinition", void 0);
__decorate([
    Column({ type: "jsonb", nullable: true }),
    __metadata("design:type", Array)
], Configuration.prototype, "categoryDefinition", void 0);
__decorate([
    Column({ type: "jsonb", nullable: true }),
    __metadata("design:type", Array)
], Configuration.prototype, "maturityDefinition", void 0);
__decorate([
    Column({ type: "jsonb", nullable: true }),
    __metadata("design:type", Array)
], Configuration.prototype, "dimensionDefinition", void 0);
__decorate([
    Column({ type: "jsonb", nullable: true }),
    __metadata("design:type", Array)
], Configuration.prototype, "secondCategoryDefinition", void 0);
__decorate([
    Column({ type: "jsonb", nullable: true }),
    __metadata("design:type", Array)
], Configuration.prototype, "dropdownFieldOneDefinition", void 0);
__decorate([
    Column({ type: "jsonb", nullable: true }),
    __metadata("design:type", Array)
], Configuration.prototype, "maturityConfiguration", void 0);
__decorate([
    Column({ type: "jsonb", nullable: true }),
    __metadata("design:type", Array)
], Configuration.prototype, "answerDefinition", void 0);
__decorate([
    Column({ type: "jsonb", nullable: true }),
    __metadata("design:type", Array)
], Configuration.prototype, "semaphoreStatusDefinition", void 0);
__decorate([
    Column({ type: "jsonb", nullable: true }),
    __metadata("design:type", Object)
], Configuration.prototype, "reportingCycle", void 0);
__decorate([
    UpdateDateColumn({ type: "timestamp", nullable: true }),
    __metadata("design:type", Date)
], Configuration.prototype, "updatedAt", void 0);
__decorate([
    Column({ type: "timestamp", nullable: true }),
    __metadata("design:type", Date)
], Configuration.prototype, "publishedAt", void 0);
__decorate([
    Column({ nullable: true }),
    __metadata("design:type", Boolean)
], Configuration.prototype, "isReportingEnabled", void 0);
__decorate([
    Column({ type: "text", nullable: true }),
    __metadata("design:type", String)
], Configuration.prototype, "homePortalAppId", void 0);
__decorate([
    OneToMany(() => DropdownOption, (dropdownOption) => dropdownOption.configuration, {
        cascade: true,
        eager: true,
        orphanedRowAction: "delete",
    }),
    __metadata("design:type", Array)
], Configuration.prototype, "dropdownOptions", void 0);
__decorate([
    OneToMany(() => CustomFieldDefinition, (customField) => customField.configuration, {}),
    __metadata("design:type", Array)
], Configuration.prototype, "customFields", void 0);
Configuration = __decorate([
    Entity()
], Configuration);
const getDropdownDefinitions = (configuration, definitionKey) => (configuration.dropdownOptions ?? [])
    .filter((option) => option.definitionKey === definitionKey)
    .sort((left, right) => (left.order ?? 0) - (right.order ?? 0))
    .map((option) => ({
    id: option.id,
    name: option.name ?? "",
    label: option.label ?? "",
    color: option.color,
    placeholder: option.placeholder ?? "",
    order: option.order ?? 0,
}));
const hydrateConfigurationDropdownDefinitions = (configuration) => {
    const statusDefinition = getDropdownDefinitions(configuration, "statusDefinition");
    const statusByOrder = new Map(statusDefinition.map((status) => [status.order, status]));
    const resolveStatusId = (level) => {
        if (!level) {
            return undefined;
        }
        return (statusByOrder.get(level.order ?? -1)?.id ??
            statusDefinition.find((status) => status.name === level.name)?.id);
    };
    configuration.statusDefinition = statusDefinition;
    configuration.degreeOfCompletionDefinition = getDropdownDefinitions(configuration, "degreeOfCompletionDefinition");
    configuration.categoryDefinition = getDropdownDefinitions(configuration, "categoryDefinition");
    configuration.secondCategoryDefinition = getDropdownDefinitions(configuration, "secondCategoryDefinition");
    configuration.dropdownFieldOneDefinition = getDropdownDefinitions(configuration, "dropdownFieldOneDefinition");
    configuration.answerDefinition = getDropdownDefinitions(configuration, "answerDefinition");
    configuration.semaphoreStatusDefinition =
        configuration.semaphoreStatusDefinition?.map((definition) => ({
            ...definition,
            low: definition.low
                ? {
                    ...definition.low,
                    id: resolveStatusId(definition.low),
                }
                : definition.low,
            medium: definition.medium
                ? {
                    ...definition.medium,
                    id: resolveStatusId(definition.medium),
                }
                : definition.medium,
            high: definition.high
                ? {
                    ...definition.high,
                    id: resolveStatusId(definition.high),
                }
                : definition.high,
        }));
    return configuration;
};

let CustomFieldDefinition = class CustomFieldDefinition {
    id;
    referenceId;
    label;
    type;
    options;
    purpose;
    enabled;
    mandatory;
    customFieldValues;
    configuration;
    flag;
};
__decorate([
    PrimaryGeneratedColumn(),
    __metadata("design:type", String)
], CustomFieldDefinition.prototype, "id", void 0);
__decorate([
    Column({ nullable: true }),
    __metadata("design:type", String)
], CustomFieldDefinition.prototype, "referenceId", void 0);
__decorate([
    Column(),
    __metadata("design:type", String)
], CustomFieldDefinition.prototype, "label", void 0);
__decorate([
    Column(),
    __metadata("design:type", String)
], CustomFieldDefinition.prototype, "type", void 0);
__decorate([
    OneToMany(() => DropdownOption, (dropdownOption) => dropdownOption.customFieldDefinition, {
        cascade: true,
        eager: true,
        orphanedRowAction: "delete",
    }),
    __metadata("design:type", Array)
], CustomFieldDefinition.prototype, "options", void 0);
__decorate([
    Column({
        type: "enum",
        enum: ["itemBasic", "itemReporting", "projectBasic", "projectReporting"],
        nullable: true,
    }),
    __metadata("design:type", String)
], CustomFieldDefinition.prototype, "purpose", void 0);
__decorate([
    Column({ default: true }),
    __metadata("design:type", Boolean)
], CustomFieldDefinition.prototype, "enabled", void 0);
__decorate([
    Column({ nullable: true }),
    __metadata("design:type", Boolean)
], CustomFieldDefinition.prototype, "mandatory", void 0);
__decorate([
    OneToMany(() => CustomFieldValue, (customFieldValue) => customFieldValue.customFieldDefinition, {
        cascade: true,
    }),
    __metadata("design:type", Array)
], CustomFieldDefinition.prototype, "customFieldValues", void 0);
__decorate([
    ManyToOne(() => Configuration, (configuration) => configuration.customFields, {
        onDelete: "CASCADE",
    }),
    __metadata("design:type", Configuration)
], CustomFieldDefinition.prototype, "configuration", void 0);
CustomFieldDefinition = __decorate([
    Entity()
], CustomFieldDefinition);

let Project = class Project {
    id;
    name;
    description;
    startDate;
    endDate;
    owner;
    customId;
    category;
    secondCategory;
    freeTextFieldOne;
    userCreatedProject;
    approvedBudget;
    spentBudget;
    managementSummary;
    challenges;
    achievements;
    nextSteps;
    reportingItems;
    customFields;
    createdAt;
    updatedAt;
    reportLastUpdatedAt;
    reportLastUpdatedBy;
    submitter;
    submittedAt;
    flag;
    /** Transient — stripped before persisting; set by the dimension report form to scope item validation. */
    _reportDimensionFilter;
    _calculated;
};
__decorate([
    PrimaryGeneratedColumn(),
    __metadata("design:type", String)
], Project.prototype, "id", void 0);
__decorate([
    Column({ nullable: true }),
    __metadata("design:type", String)
], Project.prototype, "name", void 0);
__decorate([
    Column({ type: "text", nullable: true }),
    __metadata("design:type", String)
], Project.prototype, "description", void 0);
__decorate([
    Column({ type: "date", nullable: true }),
    __metadata("design:type", String)
], Project.prototype, "startDate", void 0);
__decorate([
    Column({ type: "date", nullable: true }),
    __metadata("design:type", String)
], Project.prototype, "endDate", void 0);
__decorate([
    Column({ nullable: true }),
    __metadata("design:type", String)
], Project.prototype, "owner", void 0);
__decorate([
    Column({ nullable: true }),
    __metadata("design:type", String)
], Project.prototype, "customId", void 0);
__decorate([
    Column({ nullable: true }),
    __metadata("design:type", String)
], Project.prototype, "category", void 0);
__decorate([
    Column({ nullable: true }),
    __metadata("design:type", String)
], Project.prototype, "secondCategory", void 0);
__decorate([
    Column({ nullable: true }),
    __metadata("design:type", String)
], Project.prototype, "freeTextFieldOne", void 0);
__decorate([
    Column({ type: "boolean", nullable: true }),
    __metadata("design:type", Boolean)
], Project.prototype, "userCreatedProject", void 0);
__decorate([
    Column({
        type: "decimal",
        precision: 17,
        scale: 2,
        nullable: true,
        transformer: {
            to: (val) => (val === "" || !val ? 0 : val),
            from: (val) => parseFloat(val ?? "0"),
        },
    }),
    __metadata("design:type", Number)
], Project.prototype, "approvedBudget", void 0);
__decorate([
    Column({
        type: "decimal",
        precision: 17,
        scale: 2,
        nullable: true,
        transformer: {
            to: (val) => (val === "" || !val ? 0 : val),
            from: (val) => parseFloat(val ?? "0"),
        },
    }),
    __metadata("design:type", Number)
], Project.prototype, "spentBudget", void 0);
__decorate([
    Column({ type: "text", nullable: true }),
    __metadata("design:type", String)
], Project.prototype, "managementSummary", void 0);
__decorate([
    Column({ type: "text", nullable: true }),
    __metadata("design:type", String)
], Project.prototype, "challenges", void 0);
__decorate([
    Column({ type: "text", nullable: true }),
    __metadata("design:type", String)
], Project.prototype, "achievements", void 0);
__decorate([
    Column({ type: "text", nullable: true }),
    __metadata("design:type", String)
], Project.prototype, "nextSteps", void 0);
__decorate([
    OneToMany(() => ReportingItem, (reportingItem) => reportingItem.project, {
        cascade: true,
        eager: true,
        orphanedRowAction: "delete",
    }),
    __metadata("design:type", Array)
], Project.prototype, "reportingItems", void 0);
__decorate([
    OneToMany(() => CustomFieldValue, (customFieldValue) => customFieldValue.project, {}),
    __metadata("design:type", Array)
], Project.prototype, "customFields", void 0);
__decorate([
    CreateDateColumn(),
    __metadata("design:type", Date)
], Project.prototype, "createdAt", void 0);
__decorate([
    UpdateDateColumn(),
    __metadata("design:type", Date)
], Project.prototype, "updatedAt", void 0);
__decorate([
    Column({ nullable: true, type: "text" }),
    __metadata("design:type", String)
], Project.prototype, "reportLastUpdatedAt", void 0);
__decorate([
    Column({ nullable: true }),
    __metadata("design:type", String)
], Project.prototype, "reportLastUpdatedBy", void 0);
__decorate([
    Column({ nullable: true }),
    __metadata("design:type", String)
], Project.prototype, "submitter", void 0);
__decorate([
    Column({ nullable: true, type: "text" }),
    __metadata("design:type", String)
], Project.prototype, "submittedAt", void 0);
Project = __decorate([
    Entity()
], Project);

let CustomFieldValue = class CustomFieldValue {
    id;
    value;
    customFieldDefinition;
    reportingItem;
    project;
};
__decorate([
    PrimaryGeneratedColumn(),
    __metadata("design:type", String)
], CustomFieldValue.prototype, "id", void 0);
__decorate([
    Column({ nullable: true }),
    __metadata("design:type", String)
], CustomFieldValue.prototype, "value", void 0);
__decorate([
    ManyToOne(() => CustomFieldDefinition, (customFieldDefinition) => customFieldDefinition.customFieldValues, { onDelete: "CASCADE" }),
    __metadata("design:type", CustomFieldDefinition)
], CustomFieldValue.prototype, "customFieldDefinition", void 0);
__decorate([
    ManyToOne(() => ReportingItem, (reportingItem) => reportingItem.customFields, { onDelete: "CASCADE" }),
    __metadata("design:type", Object)
], CustomFieldValue.prototype, "reportingItem", void 0);
__decorate([
    ManyToOne(() => Project, (project) => project.customFields, {
        onDelete: "CASCADE",
    }),
    __metadata("design:type", Project)
], CustomFieldValue.prototype, "project", void 0);
CustomFieldValue = __decorate([
    Entity()
], CustomFieldValue);

let ReportingItem = class ReportingItem {
    id;
    customId;
    completionDate;
    availableBudget;
    spentBudget;
    status;
    semaphoreStatus1;
    semaphoreStatus2;
    semaphoreStatus3;
    progress;
    degreeOfCompletion;
    comment;
    attachments;
    customFields;
    severity;
    answer;
    lastUpdatedAt;
    lastUpdatedBy;
    project;
    basicItem;
    _calculated;
};
__decorate([
    PrimaryGeneratedColumn(),
    __metadata("design:type", String)
], ReportingItem.prototype, "id", void 0);
__decorate([
    Column({ nullable: true }),
    __metadata("design:type", String)
], ReportingItem.prototype, "customId", void 0);
__decorate([
    Column({ type: "timestamp", nullable: true }),
    __metadata("design:type", String)
], ReportingItem.prototype, "completionDate", void 0);
__decorate([
    Column({
        type: "decimal",
        precision: 17,
        scale: 2,
        nullable: true,
        transformer: {
            to: (val) => (val === "" || !val ? 0 : val),
            from: (val) => parseFloat(val ?? "0"),
        },
    }),
    __metadata("design:type", Number)
], ReportingItem.prototype, "availableBudget", void 0);
__decorate([
    Column({
        type: "decimal",
        precision: 17,
        scale: 2,
        nullable: true,
        transformer: {
            to: (val) => (val === "" || !val ? 0 : val),
            from: (val) => parseFloat(val ?? "0"),
        },
    }),
    __metadata("design:type", Number)
], ReportingItem.prototype, "spentBudget", void 0);
__decorate([
    Column({ nullable: true }),
    __metadata("design:type", String)
], ReportingItem.prototype, "status", void 0);
__decorate([
    Column({ nullable: true }),
    __metadata("design:type", String)
], ReportingItem.prototype, "semaphoreStatus1", void 0);
__decorate([
    Column({ nullable: true }),
    __metadata("design:type", String)
], ReportingItem.prototype, "semaphoreStatus2", void 0);
__decorate([
    Column({ nullable: true }),
    __metadata("design:type", String)
], ReportingItem.prototype, "semaphoreStatus3", void 0);
__decorate([
    Column({
        type: "decimal",
        precision: 5,
        scale: 2,
        nullable: true,
        transformer: {
            to: (val) => (val === "" || !val ? 0 : val),
            from: (val) => parseFloat(val ?? "0"),
        },
    }),
    __metadata("design:type", Number)
], ReportingItem.prototype, "progress", void 0);
__decorate([
    Column({ nullable: true }),
    __metadata("design:type", String)
], ReportingItem.prototype, "degreeOfCompletion", void 0);
__decorate([
    Column({ type: "text", nullable: true }),
    __metadata("design:type", String)
], ReportingItem.prototype, "comment", void 0);
__decorate([
    OneToMany(() => Attachment, (attachment) => attachment.reportingItem, {}),
    __metadata("design:type", Array)
], ReportingItem.prototype, "attachments", void 0);
__decorate([
    OneToMany(() => CustomFieldValue, (customFieldValue) => customFieldValue.reportingItem, {}),
    __metadata("design:type", Array)
], ReportingItem.prototype, "customFields", void 0);
__decorate([
    Column({ nullable: true }),
    __metadata("design:type", String)
], ReportingItem.prototype, "severity", void 0);
__decorate([
    Column({ nullable: true }),
    __metadata("design:type", String)
], ReportingItem.prototype, "answer", void 0);
__decorate([
    Column({ type: "timestamp", nullable: true }),
    __metadata("design:type", String)
], ReportingItem.prototype, "lastUpdatedAt", void 0);
__decorate([
    Column({ nullable: true }),
    __metadata("design:type", String)
], ReportingItem.prototype, "lastUpdatedBy", void 0);
__decorate([
    ManyToOne(() => Project, (project) => project.reportingItems, {
        onDelete: "CASCADE",
    }),
    __metadata("design:type", Project)
], ReportingItem.prototype, "project", void 0);
__decorate([
    ManyToOne(() => BasicItem, (basicItem) => basicItem.reportingItems, {
        onDelete: "CASCADE",
    }),
    __metadata("design:type", BasicItem)
], ReportingItem.prototype, "basicItem", void 0);
ReportingItem = __decorate([
    Entity()
], ReportingItem);

let Attachment = class Attachment {
    id;
    fileName;
    originalName;
    filePath;
    mimeType;
    fileSize;
    comment;
    uploadedAt;
    uploadedBy;
    temporary;
    reportingItem;
};
__decorate([
    PrimaryGeneratedColumn("uuid"),
    __metadata("design:type", String)
], Attachment.prototype, "id", void 0);
__decorate([
    Column({ nullable: true }),
    __metadata("design:type", String)
], Attachment.prototype, "fileName", void 0);
__decorate([
    Column({ nullable: true }),
    __metadata("design:type", String)
], Attachment.prototype, "originalName", void 0);
__decorate([
    Column({ nullable: true }),
    __metadata("design:type", String)
], Attachment.prototype, "filePath", void 0);
__decorate([
    Column({ nullable: true }),
    __metadata("design:type", String)
], Attachment.prototype, "mimeType", void 0);
__decorate([
    Column({ nullable: true }),
    __metadata("design:type", Number)
], Attachment.prototype, "fileSize", void 0);
__decorate([
    Column({ type: "text", nullable: true }),
    __metadata("design:type", String)
], Attachment.prototype, "comment", void 0);
__decorate([
    Column({ type: "timestamp", default: () => "CURRENT_TIMESTAMP" }),
    __metadata("design:type", String)
], Attachment.prototype, "uploadedAt", void 0);
__decorate([
    Column({ nullable: true }),
    __metadata("design:type", String)
], Attachment.prototype, "uploadedBy", void 0);
__decorate([
    Column({ default: false }),
    __metadata("design:type", Boolean)
], Attachment.prototype, "temporary", void 0);
__decorate([
    ManyToOne(() => ReportingItem, (reportingItem) => reportingItem.attachments, {
        onDelete: "CASCADE",
    }),
    __metadata("design:type", ReportingItem)
], Attachment.prototype, "reportingItem", void 0);
Attachment = __decorate([
    Entity()
], Attachment);

var TIMEFRAMES;
(function (TIMEFRAMES) {
    TIMEFRAMES["SIX_CYCLES"] = "SIX_CYCLES";
    TIMEFRAMES["TWELVE_CYCLES"] = "TWELVE_CYCLES";
    TIMEFRAMES["TWENTY_FOUR_CYCLES"] = "TWENTY_FOUR_CYCLES";
    TIMEFRAMES["ALL_CYCLES"] = "ALL_CYCLES";
})(TIMEFRAMES || (TIMEFRAMES = {}));

let DashboardContent = class DashboardContent {
    id;
    managementSummary;
};
__decorate([
    PrimaryGeneratedColumn(),
    __metadata("design:type", String)
], DashboardContent.prototype, "id", void 0);
__decorate([
    Column({ type: "text", nullable: true }),
    __metadata("design:type", String)
], DashboardContent.prototype, "managementSummary", void 0);
DashboardContent = __decorate([
    Entity()
], DashboardContent);

const DEFAULT_LANGUAGE = "en";
const SUPPORTED_LANGUAGES = ["en", "de"];
/**
 * Normalizes an arbitrary (possibly missing or invalid) language value to a
 * supported language, falling back to English. Use this everywhere an
 * untrusted or legacy value (e.g. from an HTTP payload or a pre-existing
 * database row) needs to become a safe `SupportedLanguage`.
 */
const normalizeLanguage = (language) => SUPPORTED_LANGUAGES.includes(language)
    ? language
    : DEFAULT_LANGUAGE;

let ManagedUser = class ManagedUser {
    id;
    profile;
    createdAt;
    updatedAt;
};
__decorate([
    PrimaryGeneratedColumn(),
    __metadata("design:type", String)
], ManagedUser.prototype, "id", void 0);
__decorate([
    Column({ type: "jsonb" }),
    __metadata("design:type", Object)
], ManagedUser.prototype, "profile", void 0);
__decorate([
    CreateDateColumn(),
    __metadata("design:type", Date)
], ManagedUser.prototype, "createdAt", void 0);
__decorate([
    UpdateDateColumn(),
    __metadata("design:type", Date)
], ManagedUser.prototype, "updatedAt", void 0);
ManagedUser = __decorate([
    Entity()
], ManagedUser);

let TableConfiguration = class TableConfiguration {
    id;
    component;
    columns;
};
__decorate([
    PrimaryGeneratedColumn(),
    __metadata("design:type", String)
], TableConfiguration.prototype, "id", void 0);
__decorate([
    Column({ type: "text", nullable: true }),
    __metadata("design:type", String)
], TableConfiguration.prototype, "component", void 0);
__decorate([
    Column({ type: "jsonb", nullable: true }),
    __metadata("design:type", Array)
], TableConfiguration.prototype, "columns", void 0);
TableConfiguration = __decorate([
    Entity()
], TableConfiguration);

const COLORS = ["#EEF7F1", "#FEFBF0", "#fae7e7"];
const CONTRAST_TEXT_COLORS = ["#3B7D57", "#A36200", "#D60000"];
const ICONS = [
    "mood-smile.svg",
    "mood-neutral.svg",
    "mood-sad.svg",
];

let UserSettings = class UserSettings {
    id;
    email;
    tutorialCompleted;
    setupSkipped;
    skipChangedFieldDialog;
    isSetupSkipped;
    createdAt;
    updatedAt;
};
__decorate([
    PrimaryGeneratedColumn(),
    __metadata("design:type", String)
], UserSettings.prototype, "id", void 0);
__decorate([
    Column({ unique: true }),
    __metadata("design:type", String)
], UserSettings.prototype, "email", void 0);
__decorate([
    Column({ type: "boolean", default: false }),
    __metadata("design:type", Boolean)
], UserSettings.prototype, "tutorialCompleted", void 0);
__decorate([
    Column({ type: "boolean", default: false }),
    __metadata("design:type", Boolean)
], UserSettings.prototype, "setupSkipped", void 0);
__decorate([
    Column({ type: "boolean", default: false }),
    __metadata("design:type", Boolean)
], UserSettings.prototype, "skipChangedFieldDialog", void 0);
__decorate([
    Column({ type: "boolean", default: false }),
    __metadata("design:type", Boolean)
], UserSettings.prototype, "isSetupSkipped", void 0);
__decorate([
    CreateDateColumn(),
    __metadata("design:type", Date)
], UserSettings.prototype, "createdAt", void 0);
__decorate([
    UpdateDateColumn(),
    __metadata("design:type", Date)
], UserSettings.prototype, "updatedAt", void 0);
UserSettings = __decorate([
    Entity()
], UserSettings);

let ViewConfiguration = class ViewConfiguration {
    id;
    displayTabs;
    canEdit;
    isAiEnabled;
    type;
    tabs;
};
__decorate([
    PrimaryGeneratedColumn(),
    __metadata("design:type", String)
], ViewConfiguration.prototype, "id", void 0);
__decorate([
    Column({ type: "boolean", default: false }),
    __metadata("design:type", Boolean)
], ViewConfiguration.prototype, "displayTabs", void 0);
__decorate([
    Column({ type: "boolean", default: false }),
    __metadata("design:type", Boolean)
], ViewConfiguration.prototype, "canEdit", void 0);
__decorate([
    Column({ type: "boolean", default: false }),
    __metadata("design:type", Boolean)
], ViewConfiguration.prototype, "isAiEnabled", void 0);
__decorate([
    Column({
        type: "enum",
        enum: ["dashboard", "overview", "project-common", "project-specific"],
    }),
    __metadata("design:type", String)
], ViewConfiguration.prototype, "type", void 0);
__decorate([
    Column({ type: "jsonb", nullable: true }),
    __metadata("design:type", Array)
], ViewConfiguration.prototype, "tabs", void 0);
ViewConfiguration = __decorate([
    Entity()
], ViewConfiguration);

export { Attachment, BasicItem, COLORS, CONFIGURATION_DROPDOWN_DEFINITION_KEYS, CONTRAST_TEXT_COLORS, Configuration, CustomFieldDefinition, CustomFieldValue, DEFAULT_LANGUAGE, DashboardContent, DropdownOption, ICONS, ITEM_NAMES, ManagedUser, PROJECT_NAMES, Project, ReportingItem, SUPPORTED_LANGUAGES, TIMEFRAMES, TableConfiguration, UserSettings, ViewConfiguration, hydrateConfigurationDropdownDefinitions, normalizeLanguage };
